// Menú de navegación de la app. Se filtra por rol salvo que el usuario tenga
// menú personalizado (User.menuPersonalizado + User.menuIds desde Admin > Usuarios),
// en cuyo caso ve exactamente los ids de menuIds, sin importar su rol.

export const TODOS = ['admin', 'solicitante', 'finanzas'];
export const CON_DIRECTOR = [...TODOS, 'director', 'contador', 'programacion'];
export const CON_DASHBOARD = ['admin', 'finanzas', 'director', 'contador', 'programacion'];

export const NAV = [
  { id: 'dashboard', label: 'Dashboard', roles: CON_DASHBOARD },
  // Tablero de decisión para dirección general. De momento sólo admin: se abrirá
  // a dirección cuando esté validado con ellos. No expone datos nuevos — lee el
  // mismo /dashboard/analytics que ya usa el Dashboard.
  { id: 'direccion-general', label: 'Dirección General', roles: ['admin'] },
  { id: 'mi-dashboard', label: 'Mi Dashboard', roles: ['solicitante'] },
  { id: 'historial-general', label: 'Historial General', roles: CON_DIRECTOR },
  // Carga masiva de comprobantes del banco: propone la solicitud de cada uno y se confirma
  { id: 'comprobantes-masivos', label: 'Subir comprobantes', roles: ['admin', 'programacion'] },
  // Pagos que ya debieron cerrarse (pagados con comprobante) y no lo están
  { id: 'cierre-pagos', label: 'Cierre de pagos', roles: ['admin', 'finanzas', 'programacion'] },
  {
    group: 'g-solicitudes', label: 'Solicitudes',
    children: [
      { id: 'nueva',                       label: 'Gastos en General',     roles: TODOS },
      { id: 'nueva-debito',                label: 'Débito',                roles: TODOS },
      { id: 'nueva-contribuciones',        label: 'Contribuciones',        roles: TODOS },
      { id: 'nueva-activos-fijos',         label: 'Activos Fijos',         roles: TODOS },
      { id: 'nueva-mercancias-nacionales', label: 'Mercancías Nacionales',  roles: TODOS },
      { id: 'nueva-nomina',                label: 'Pago de Nómina',          roles: TODOS },
      { id: 'nueva-caja-chica',            label: 'Comprobación Caja Chica', roles: TODOS },
      { id: 'nueva-reembolso-gastos',      label: 'Reembolso de Gastos',     roles: TODOS },
      { id: 'nueva-complemento-importacion', label: 'Complemento Costo Importación', roles: TODOS },
      { id: 'reembolso',                   label: 'Reembolso',               roles: TODOS },
      { id: 'finiquito',                   label: 'Finiquito',              roles: TODOS },
      { id: 'pagadas-contador',            label: 'Solicitudes Pagadas',    roles: ['contador'] },
      { id: 'provision-contador',          label: 'Para Provisión',         roles: ['contador'] },
    ],
  },
  {
    group: 'g-comprobaciones', label: 'Comprobaciones',
    children: [
      { id: 'comprobacion',             label: 'Nueva Comprobación',       roles: TODOS },
      { id: 'historial-comprobaciones', label: 'Historial Comprobaciones', roles: CON_DIRECTOR },
    ],
  },
  {
    group: 'g-requisiciones', label: 'Requisiciones',
    children: [
      { id: 'nueva-requisicion',       label: 'Nueva Requisición',       roles: ['admin', 'solicitante'] },
      { id: 'historial-requisiciones', label: 'Historial Requisiciones', roles: ['admin', 'solicitante', 'jefe_compras', 'comprador'] },
      // Bandeja de aprobación (área y Finanzas): la ve quien es aprobador, sea cual sea su rol (ver permitidoMenu)
      { id: 'aprobar-requisiciones',   label: 'Requisiciones por aprobar', roles: ['admin'] },
      { id: 'reporte-requisiciones',   label: 'Reporte de Requisiciones', roles: ['admin', 'jefe_compras', 'finanzas'] },
      { id: 'catalogo-materiales',     label: 'Catálogo de Productos',   roles: ['admin', 'comprador', 'jefe_compras'] },
      { id: 'direcciones-entrega',     label: 'Direcciones de Entrega',  roles: ['admin', 'jefe_compras'] },
    ],
  },
  { id: 'captura-comprobantes', label: 'Captura de Comprobantes', roles: [...TODOS, 'contador', 'programacion'] },
  { id: 'comparativo', label: 'Comparativo Cotizaciones', roles: [...TODOS, 'comprador', 'jefe_compras'] },
  { id: 'presupuestos', label: 'Presupuestos', roles: ['admin', 'finanzas', 'director'] },
  { id: 'reporte',   label: 'Reporte Pipeline',    roles: ['admin', 'finanzas'] },
  // Cuentas de cada compañía de las que salen los pagos (las elige tesorería al pagar)
  { id: 'cuentas-bancarias', label: 'Cuentas Bancarias', roles: ['admin', 'finanzas'] },
  { id: 'polizas-contables', label: 'Pólizas Contables', roles: ['admin', 'contador', 'finanzas'] },
  { id: 'borradas',  label: 'Papelera (Borradas)', roles: ['admin', 'contador'] },
  { id: 'admin',     label: 'Administración',       roles: ['admin'] },
  { id: 'catalogos', label: 'Catálogos',            roles: ['finanzas'] },
  // Tokens para agentes de IA (MCP de solo lectura): cada usuario los suyos
  { id: 'agentes-ia', label: 'Agentes de IA',        roles: ['admin'] },
];

// Tipos de solicitud disponibles para crear (filtrados por rol/menú personalizado)
export const TIPOS_NUEVA = [
  { id: 'nueva',                       label: 'Gastos en General',    desc: 'Pago de facturas y gastos operativos',    roles: TODOS },
  { id: 'nueva-debito',                label: 'Débito',               desc: 'Cargos directos a cuenta bancaria',        roles: TODOS },
  { id: 'nueva-contribuciones',        label: 'Contribuciones',       desc: 'Pagos fiscales y contribuciones',          roles: TODOS },
  { id: 'nueva-activos-fijos',         label: 'Activos Fijos',        desc: 'Adquisición de maquinaria y equipo',       roles: TODOS },
  { id: 'nueva-mercancias-nacionales', label: 'Mercancías Nacionales', desc: 'Compra de mercancía para reventa',         roles: TODOS },
  { id: 'nueva-nomina',                label: 'Pago de Nómina',         desc: 'Sueldos, salarios y conceptos de nómina',    roles: TODOS },
  { id: 'nueva-caja-chica',            label: 'Comprobación Caja Chica', desc: 'Gastos menores con comprobante por concepto', roles: TODOS },
  { id: 'nueva-reembolso-gastos',      label: 'Reembolso de Gastos',   desc: 'Gastos reembolsables con comprobante por concepto', roles: TODOS },
  { id: 'nueva-complemento-importacion', label: 'Complemento Costo Importación', desc: 'Fletes, agente aduanal, maniobras y almacenajes de una importación', roles: TODOS },
  { id: 'reembolso',                   label: 'Reembolso',             desc: 'Reembolso de gastos a colaboradores',     roles: TODOS },
  { id: 'finiquito',                   label: 'Finiquito',             desc: 'Liquidación y finiquito de personal',     roles: TODOS },
];

// Lista plana de todos los ítems de menú (para el checklist de "menú personalizado"
// en Admin > Usuarios y para resolver permisos por id, sin importar si es un ítem
// suelto o un hijo de un grupo).
export const ALL_MENU_ITEMS = NAV.flatMap(entry =>
  entry.children
    ? entry.children.map(c => ({ id: c.id, label: c.label, roles: c.roles, grupo: entry.label }))
    : [{ id: entry.id, label: entry.label, roles: entry.roles, grupo: null }]
);

const ROLES_POR_ID = Object.fromEntries(ALL_MENU_ITEMS.map(i => [i.id, i.roles]));

// ¿El usuario tiene permitido este ítem de menú? Si tiene menú personalizado
// activo, se rige 100% por menuIds (independiente de su rol); si no, por rol.
// 'catalogos' tiene además su propio permiso independiente: si el admin le
// asignó catálogos puntuales (User.catalogosPermitidos), el menú aparece sin
// importar su rol ni si además usa menú personalizado.
export function permitidoMenu(user, id) {
  if (id === 'catalogos' && (user?.catalogosPermitidos || []).length > 0) return true;
  // Los tokens de agentes solo los administra el admin
  if (id === 'agentes-ia') return user?.rol === 'admin';
  // Aprobadores de requisiciones: cualquier rol, aunque tenga menú personalizado
  if (id === 'aprobar-requisiciones') return user?.rol === 'admin' || Boolean(user?.esAprobadorRequisiciones);
  if (user?.menuPersonalizado) return (user.menuIds || []).includes(id);
  return (ROLES_POR_ID[id] || []).includes(user?.rol);
}

export function navForUser(user) {
  return NAV.map(entry => {
    if (!entry.children) return permitidoMenu(user, entry.id) ? entry : null;
    const children = entry.children.filter(c => permitidoMenu(user, c.id));
    return children.length ? { ...entry, children } : null;
  }).filter(Boolean);
}
